import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";
import TabsNavbar from "../Components/Common/TabsNavBar/TabsNavbar";
import IaAdminPrompts from "../Components/Ia/Admin/IaAdminPrompts";
import IaAdminDocuments from "../Components/Ia/Admin/IaAdminDocuments";
import IaAdminConversations from "../Components/Ia/Admin/IaAdminConversations";
import "../Components/Ia/Admin/IaAdmin.css";

const TABS = ["Prompts", "Documents", "Conversations"];

/** Administration de l'assistant IA. Reservee au role admin (userRole 1). */
const IaAdminView = () => {
  const { t } = useTranslation("common");
  const { user } = useSelector((state) => state.userReducer);
  const [activeTab, setActiveTab] = useState(TABS[0]);

  // Double barriere : la route est deja conditionnee par le role dans
  // Routes.jsx, mais une URL tapee a la main ne doit rien afficher non plus.
  if (user?.attributes?.userRole !== 1) return <Navigate to="/" />;

  return (
    <ViewScroller>
      <div className="w100 d-flex flex-column gap-4 h-100 pe-4">
        <div>
          <h1 className="f22 sBold iaBlue mb-1">{t("AI Assistant")}</h1>
          <p className="f13 normal text-lightBlack mb-0">
            {t("Visible only to administrators")}
          </p>
        </div>

        <TabsNavbar tabs={TABS} activeTab={activeTab} setActiveTab={setActiveTab} />

        <div className="pt-3">
          {activeTab === "Prompts" && <IaAdminPrompts />}
          {activeTab === "Documents" && <IaAdminDocuments />}
          {activeTab === "Conversations" && <IaAdminConversations />}
        </div>
      </div>
    </ViewScroller>
  );
};

export default IaAdminView;
